function getInitialPartnerPrivacy() {
  const defaults = { mostrar_email: 1, mostrar_rfc: 1 };

  if (typeof window === 'undefined') return defaults;

  try {
    const raw = window.localStorage.getItem('partnerPrivacy');
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    return {
      mostrar_email: Number(parsed?.mostrar_email) ? 1 : 0,
      mostrar_rfc: Number(parsed?.mostrar_rfc) ? 1 : 0,
    };
  } catch (e) {
    return defaults;
  }
}

const state = {
  partner: {},
  partnerToken: null,
  partnerTokenTime: null,
  partnerPrivacy: getInitialPartnerPrivacy(),
  sendForm: [],
};

export default state;
